import { ExternalType } from "./type.js";
import { postSplitOrderDataNew } from "./kujiale/getCurrentCupboardInfo.js";
import { externalFactory } from "./externalFactory.js";
import { getCurrentCupboardInfoV2 } from "./caxa/directive/getCurrentCupboardInfoV2.js";
const externalGetCurrentCupboardInfoV2 = externalFactory(async (params) => {
  const { type } = params;
  switch (type) {
    case ExternalType.caxa:
      return await getCurrentCupboardInfoV2(params.arg, params.sequenceId);
    case ExternalType.kujiale:
      if (params.preTest) {
        return await postSplitOrderDataNew({
          fileIds: params.arg.fileIds,
          softwareType: "kujiale"
        });
      } else {
        return await postSplitOrderDataNew({
          fileIds: params.arg.fileIds,
          softwareType: "kujiale"
        });
      }
    default:
      throw new Error(`\u8BE5\u65B9\u6CD5\uFF0C\u6682\u4E0D\u652F\u6301${type}\u7C7B\u578B\u7684\u5916\u90E8\u7CFB\u7EDF`);
  }
});
export { externalGetCurrentCupboardInfoV2 };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/externalGetCurrentCupboardInfoV2.js